import React, { useEffect } from "react";
import { Button, Modal, Form, Input, Row, Col, message } from "antd";
import API from "../../../services/api-request";

const EditClients = (props) => {
  const [editForm] = Form.useForm();

  const handleCancel = () => {
    props.onShowEdit(false);
    editForm.setFieldsValue({});
  };

  const onFinish = async (values) => {
    const { name, address } = values;

    const dataForm = {
      name,
      address,
      id: props.selectedData.id,
    };

    await API.Post("client/update", dataForm)
      .then(() => {
        message.success("Client has been saved");
        props.onGetClients();
        editForm.resetFields();
        props.onShowEdit(false);
      })
      .catch((err) => {
        console.error(err);
        if (!err.response.data) {
          message.info("Failed add client");
        }

        message.info(
          `${err.response.data.errors[0].path} ${err.response.data.errors[0].msg}`
        );
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    editForm.setFieldsValue(props.selectedData);
    // eslint-disable-next-line
  }, [props.selectedData]);

  return (
    <>
      <Modal
        title="Edit Users"
        open={props.showEdit}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={() => editForm.submit()}>
            Save
          </Button>,
        ]}
      >
        <Form
          form={editForm}
          name="Edit Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please input your name!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Address"
                name="address"
                rules={[
                  { required: true, message: "Please input your address!" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default EditClients;
